module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/portfolio/projects/basicjane/basicjane.component.scss
// module id = ./src/app/pages/portfolio/projects/basicjane/basicjane.component.scss
// module chunks = main